import { useTeamsLoginMutation } from 'gcs-common/clients/api/entities/auth/auth-api';
import { CODE_ROUTES, LOGIN_ROUTES } from 'gcs-common/constants/routes';
import { THEME } from 'gcs-common/constants/themes';
import useMsTeamsClient from 'gcs-common/hooks/useMsTeamsClient';
import { openErrorDialog } from 'gcs-common/slices/errorDialogSlice/errorDialogSlice';
import {
  getApiBaseUrl,
  getAppName,
  getChatLogo,
  getLogo,
  getThemeIdentifier,
} from 'gcs-common/slices/theme/themeSelectors';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import digiBoxIcon from '../../../img/digital_box.svg';
import Button from '../../Button/Button';
import MessageLikeTextBox from '../../MessageLikeTextBox/MessageLikeTextBox';
import styles from './styles.module.scss';

const LoginClassic = () => {
  const { isInitialized: isTeamsClientInitialized, getAuthToken, error: teamsError } = useMsTeamsClient();
  const teamsLoginMutaion = useTeamsLoginMutation();
  const dispatch = useDispatch();

  const logo = useSelector(getLogo);
  const chatLogo = useSelector(getChatLogo);
  const navigate = useNavigate();

  const appName = useSelector(getAppName);
  const apiBaseUrl = useSelector(getApiBaseUrl);

  const theme = useSelector(getThemeIdentifier);

  const msLogin = async () => {
    if (teamsError) {
      dispatch(
        openErrorDialog({
          dialogErrorMsg: 'Beim Anmelden ist ein Fehler aufgetreten.',
          dialogErrorCode: 'ClientError',
        }),
      );
    }
    const token = await getAuthToken();
    if (!token) {
      dispatch(
        openErrorDialog({ dialogErrorMsg: 'Beim Anmelden ist ein Fehler aufgetreten.', dialogErrorCode: 'TokenError' }),
      );
    }
    teamsLoginMutaion.mutateAsync({ body: { token } });
  };

  const isAgentBeem = theme === THEME.AGENT;

  function handleLogin() {
    navigate(CODE_ROUTES.REQUEST_CODE);
  }

  return (
    <div className={styles.loginRoot}>
      <div className={styles.loginOverlay} />
      <div className={styles.loginWrapper}>
        <img alt="gc-chat-logo" className={`${isAgentBeem ? styles.chatLogoBeem : styles.chatLogo}`} src={logo} />
        {!isAgentBeem && <img alt="gc-chat-text" className={styles.chatText} src={chatLogo} />}
        {isAgentBeem ? (
          <MessageLikeTextBox className={styles.welcome}>
            Willkommen bei
            {` ${appName}`}!
          </MessageLikeTextBox>
        ) : (
          <MessageLikeTextBox className={styles.welcome}>
            Willkommen beim
            {` ${appName}`}
            -Chat!
          </MessageLikeTextBox>
        )}
        {isTeamsClientInitialized ? (
          <Button className={styles.loginButton} onClick={() => msLogin()}>
            Mit Teams anmelden
          </Button>
        ) : (
          <>
            <Button
              className={styles.loginButton}
              onClick={() => {
                window.location = `${apiBaseUrl}/saml/authorize`;
              }}
            >
              Mit Microsoft anmelden
            </Button>
            <Button className={styles.loginButton} onClick={handleLogin}>
              Login
            </Button>
          </>
        )}
      </div>
      {isAgentBeem && <img className={styles.digiBoxIcon} alt="" src={digiBoxIcon} />}
      {isAgentBeem && (
        <div className={styles.linksWrapper}>
          <Link to={LOGIN_ROUTES.LOGIN_TERMS} className={styles.termCondition}>
            Nutzungsbedingungen & Datenschutzrichtlinien
          </Link>
          <Link to={LOGIN_ROUTES.LOGIN_IMPRINT} className={styles.termCondition}>
            Impressum
          </Link>
        </div>
      )}
    </div>
  );
};

export default LoginClassic;

LoginClassic.propTypes = {};
